export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/LayerSwitcher/GPopacitySlider.png?8e3f7dc44180af6b644f695401033e10";